if (!customElements.get('predictive-search')) {
customElements.define('predictive-search', class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.mobileViewAll = this.querySelector('[data-mobile-search-view-all]');
  }

  connectedCallback() {
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.predictiveSearchResults.style.display = 'none';

      if (this.mobileViewAll) {
        this.mobileViewAll.classList.add('hidden');
      }

      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search&resources[type]=product,page,collection,query`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }

      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.open();
    })
    .catch((error) => {
      this.close();
      throw error;
    });
}

  open() {
    this.predictiveSearchResults.style.display = 'block';

    const viewAllButton = this.predictiveSearchResults.querySelector('[data-predictive-search-view-all]');

    if (this.mobileViewAll) {
      if (viewAllButton) {
        this.mobileViewAll.classList.remove('hidden');
      } else {
        this.mobileViewAll.classList.add('hidden');
      }
    }
  }

  close() {
    const headerSearchClose = document.querySelector('[data-header-search-close]');

    if (headerSearchClose) {
      headerSearchClose.click();
    }

    this.predictiveSearchResults.style.display = 'none';

    if (this.mobileViewAll) {
      this.mobileViewAll.classList.add('hidden');
    }
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
});
}
